import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from '@bookly/shared';

import { UserResult } from '../model/user-management.model';

@Injectable({
  providedIn: 'root',
})
export class UserManagementApiService {
  readonly #http = inject(HttpClient);
  readonly #managementUrl = environment.shared.userManagementApi;

  public getUsers(query?: string) {
    return this.#http.get<UserResult[]>(
      `${this.#managementUrl}user-search/${query ? query : ''}`
    );
  }
}
